import { LISTING_PATH, isDataElementListing } from '@/pages/Submittals/listing-config'

export const authGuard = meta => {
  if (!meta?.consultant) {
    // A data element's listing is sent on as the bare listing rather than
    // itself. The login page reads the segment after `/submittals/` as the
    // submittal id to auto-login against, so handing it `/submittals/de/<id>`
    // would have it chase a submittal called "de" — and a truthy id there also
    // forces the email step, so a refresh mid-OTP loses the prefilled address.
    //
    // Done here because this guard is the only thing in the system that writes
    // `?redirectTo=`; the notification emails link at `/submittals/<id>` direct.
    // Keeping the login page's parse untouched is the point — it is shared with
    // the consultant deep-link flow and has nothing to do with the sidebar.
    //
    // The cost is that a consultant who follows a listing link while signed out
    // lands on the first data element rather than the linked one. Only a
    // hand-shared URL reaches that case, and the listing it lands on is a real
    // one; the emailed submittal links that drive auto-login are untouched.
    const pathname = meta?.pathname
    if (!pathname) return '/login'

    const target = isDataElementListing(pathname) ? LISTING_PATH : pathname + (meta?.search ?? '')
    return `/login?redirectTo=${encodeURIComponent(target)}`
  }
  return null
}
